import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { User } from '@app/_models';
import { CommonUtility } from '@app/_modules/commonUtility';
import { environment } from '@environments/environment';
import { Observable } from "rxjs";
import * as CryptoJS from 'crypto-js';
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormGroup } from '@angular/forms';
@Injectable({ providedIn: 'root'
})
export class CategoryService {
  emailText:any;
  form: FormGroup;
  commonUtility:CommonUtility;
  Base_url;
  isgPay_url;
  constructor(
    private router: Router,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) {
    this.Base_url = environment.Base_url;
    this.isgPay_url =environment.isgPayUrl;
    this.commonUtility = new CommonUtility(snackBar);
  }

  submitHindiDetails(req,token){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
        'token': token
      });
      let url = `${this.Base_url}cessservice/submitHindiDetails`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }

    fetchBySubscriptionType(req){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
      });
      let url = `${this.Base_url}cessservice/fetchBySubscriptionType`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }

    passEncry(DATA,uname){
      console.log(' DATA+uname : ' +DATA+uname);
      console.log(' DATA uname : ' +DATA+''+uname);
      var pass = CryptoJS.SHA512(DATA+uname);
      return pass
    }


  }



